import { isAnyLocal } from '@lib/environments.const';
/**
 * Checks if the current branch is not deployed in the preview (Deployment Previews).
 * @param branchName current branch name.
 * @returns true if the current branch is not deployed in the preview.
 */
export const isNotDeploymentPreview = <T>(branchName: T | string): boolean => {
  return !branchName || branchName === 'master';
};

export const getBranchName = <T>(branchName: T): string => {
  if (isAnyLocal() || isNotDeploymentPreview(branchName)) return '';

  return '/' + branchName;
};

export const getScriptUrl = (): string => {
  return navigator.serviceWorker.controller?.scriptURL.split('/').pop();
};

export const unregisterAppServiceWorker = async (): Promise<boolean> => {
  if (getScriptUrl() === 'app.sw.js') {
    return (await navigator.serviceWorker.ready).unregister();
  }
};
